import { useRef } from 'react';
import VideoIntro from '../audio/Intro-video.mp4';
import audio from '../audio/Voice 005.m4a';
import './videoShow.css';

export const VideoShow = () => {
  const videoContainerRef = useRef(null);
  const videoShowRef = useRef(null);
  const videoRef = useRef(null);
  const videoContentRef = useRef(null);

  const handleVideoBtnClick = () => {
    const videoContainer = videoContainerRef.current;
    const videoShow = videoShowRef.current;
    const video = videoRef.current;
    const videoContent = videoContentRef.current;

    const audio = document.querySelector('#background-audio')
    audio.play();

    videoContainer.style.width = "100%";
    videoContainer.style.height = "100%";

    videoShow.style.background = `linear-gradient(rgba(165, 165, 100, 0.5), #202020 , url('../images/coffee-cafe.jpg'))`;

    if (video.classList.contains('d-none')) {
      video.classList.remove('d-none');
      videoContent.classList.add('d-none');
      video.play();
    } else {
      video.classList.add('d-none');
      videoContent.classList.remove('d-none');
      video.pause();
      video.currentTime = 0;
    }
  };

  const handleVideoTimeUpdate = () => {
    const video = videoRef.current;
    const videoContent = videoContentRef.current;

    if (video.currentTime >= video.duration) {
      videoContent.classList.remove('d-none');
      video.classList.add('d-none');
    }
  };

  return (
    <div className="videoShow my-5 bg-dark container" style={{ position: "relative" }} ref={videoShowRef}>
      <div className="content" id="videoContent" ref={videoContentRef}>
        <h2 className='text-effect'>Introduce Myself</h2>
        <audio id="background-audio" preload="auto" autoPlay="">
          <source
            src={audio}
            type="audio/mpeg"
          />
        </audio> 
        <button className="btn btn-outline-danger" id="watchVideoBtn" onClick={handleVideoBtnClick}>
          Watch The Video{" "}
          <span>
            <i className="fa-brands fa-youtube" />
          </span>
        </button>
      </div>
      <div id="videoContainer" className="mt-4" ref={videoContainerRef}>
        <video
          id="introVideo"
          width="100%"
          height="100%"
          className="d-none"
          controls
          ref={videoRef}
          onTimeUpdate={handleVideoTimeUpdate}
        >
          <source
            src={VideoIntro}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

export default VideoShow;
